import React, { useCallback, useEffect, useMemo, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Button } from "reactstrap"
import { FilterData } from "components/Extra"
import { AddNewOffer } from "./Modals/AddNewOffer/AddNewOffer"
import { IndexType } from "components/Extra"
import OffersTable from "./OffersTable"
import { useNavigate } from "react-router-dom"
import { OffersGrid } from "./OffersGrid"
import { LicenseDetails } from "pages/vendor/Offers/Modals/LicenseDetails"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import classNames from "classnames"

export enum CurrentTapType {
  all = "campaigns_all",
  active = "campaigns_active",
  inActive = "campaigns_inActive",
  ended = "campaigns_ended",
}

const tabs = [
  CurrentTapType.all,
  CurrentTapType.active,
  CurrentTapType.inActive,
  CurrentTapType.ended,
]

export interface Offer {
  title: string
  id: string
  category: string
  startDate: string
  endDate: string
  periodTime: string
  price: string
  status: CurrentTapType.active | CurrentTapType.inActive | CurrentTapType.ended
}

const offersData: Offer[] = [
  {
    title: "offer Title",
    id: "ID-145871",
    category: "Banner",
    startDate: "25 May, 2025",
    endDate: "12 Aug, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.active,
  },
  {
    title: "offer Title",
    id: "ID-145872",
    category: "Featured",
    startDate: "25 Aug, 2025",
    endDate: "12 Sep, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.active,
  },
  {
    title: "offer Title",
    id: "ID-145873",
    category: "Email offers",
    startDate: "25 Aug, 2025",
    endDate: "12 Sep, 2025",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.inActive,
  },
  {
    title: "offer Title",
    id: "ID-145874",
    category: "Video offers",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "offer Title",
    id: "ID-145875",
    category: "Mobile offers",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "offer Title",
    id: "ID-145876",
    category: "Featured",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
  {
    title: "offer Title",
    id: "ID-145877",
    category: "Banner",
    startDate: "25 May, 2023",
    endDate: "12 Jun, 2023",
    periodTime: "1:00 Pm. To 2:00 Pm.",
    price: "QAR 50",
    status: CurrentTapType.ended,
  },
]

const Offers = () => {
  const { t } = useTranslation()

  const [currentTap, setCurrentTap] = useState<CurrentTapType>(CurrentTapType.all)
  const [activeTab, setActiveTab] = useState<IndexType>("list-ul")
  const [checkedOffers, setcheckedOffers] = useState<Offer[]>([])
  const [offers, setoffers] = useState<Offer[]>([])
  const [filteredoffers, setFilteredoffers] = useState<Offer[]>([])
  const [showAddNewoffer, setShowAddNewoffer] = useState(false)
  const [showLicenseDetails, setShowLicenseDetails] = useState(false)

  const navigate = useNavigate()
  useEffect(() => {
    setFilteredoffers(offersData)
    setoffers(offersData)
  }, [])

   const changeTabHandler = useCallback(
     (tab: CurrentTapType) => {
       setCurrentTap(tab)
       if (tab === CurrentTapType.all) {
         setFilteredoffers(offers)
       } else {
         setFilteredoffers(
           offers.filter(offer => offer.status === tab)
         )
       }
     },
     [offers]
   )

  const addNewOfferHandler = () => {
    setShowAddNewoffer(true)
  }
  const viewDetailsHandler = useCallback((offer: Offer) => {
    navigate(`/offers/${offer.id}`)
  }, [])

  const isAllChecked = useMemo(() => {
    return offers.length > 0 && checkedOffers.length === offers.length
  }, [offers, checkedOffers])

  const toggleAllOffers = useCallback(() => {
    setcheckedOffers(isAllChecked ? [] : offers)
  }, [isAllChecked, offers])

  const togglecheckedOfferHandler = useCallback((offer: Offer) => {
    setcheckedOffers(prev =>
      prev.includes(offer) ? prev.filter(o => o !== offer) : [...prev, offer]
    )
  }, [])

  const toggleActiveOffer = useCallback(
    (offer: Offer) => {
      setoffers(prev =>
        prev.map(o =>
          o.id === offer.id
            ? {
                ...o,
                status: o.status === CurrentTapType.active
                  ? CurrentTapType.inActive
                  : CurrentTapType.active,
              }
            : o
        )
      )
    },
    [offers]
  )
  const editOfferHandler = useCallback((offer: Offer) => {}, [])
  const reOrderOfferHandler = useCallback(() => {}, [])
  const deleteOfferHandler = useCallback((offer: Offer) => {}, [])

  return (
    <div className="page-content">
      <div className="container-fluid d-flex justify-content-between align-items-center">
        <Breadcrumbs
          title={t("dashboard_dashboard")}
          breadcrumbItem={t("offers_offers")}
        />
        <Button
          onClick={addNewOfferHandler}
          color="success"
          className="bg-gradiant-blue text-capitalize border-0"
        >
          {t("offers_addNewOffer")}
        </Button>
      </div>

      <ul className="nav nav-pills mb-3 px-2">
        {tabs.map(tab => (
          <li
            className="nav-item"
            style={{ flex: 1, textAlign: "center" }}
            key={tab}
          >
            <Link
              to="#"
              className={classNames({ active: currentTap === tab }, "nav-link")}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onClick={() => changeTabHandler(tab)}
            >
              {t(tab)}
            </Link>
          </li>
        ))}
      </ul>

      <FilterData
        data={offers}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        bearerFilteredData={setFilteredoffers}
      />

      {/* Modals */}
      <AddNewOffer
        isOpen={showAddNewoffer}
        toggle={() => setShowAddNewoffer(false)}
        formSubmitedHandler={() => setShowLicenseDetails(true)}
      />
      <LicenseDetails
        isOpen={showLicenseDetails}
        toggle={() => setShowLicenseDetails(false)}
      />

      {activeTab == "list-ul" ? (
        <OffersTable
          offers={filteredoffers}
          isAllChecked={isAllChecked}
          checkedOffers={checkedOffers}
          toggleAllOffers={toggleAllOffers}
          togglecheckedOfferHandler={togglecheckedOfferHandler}
          toggleActiveOffer={toggleActiveOffer}
          editOfferHandler={editOfferHandler}
          viewDetailsHandler={viewDetailsHandler}
          deleteOfferHandler={deleteOfferHandler}
        />
      ) : (
        <OffersGrid
          offers={filteredoffers}
          toggleActiveOffer={toggleActiveOffer}
          editOfferHandler={editOfferHandler}
          viewDetailsHandler={viewDetailsHandler}
          reOrderOfferHandler={reOrderOfferHandler}
          deleteOfferHandler={deleteOfferHandler}
        />
      )}
    </div>
  )
}

export default Offers
